import { useEffect, useReducer } from 'react';

const TICK_INTERVAL_MS = 1000;

const computeRemainingMs = (endTimeMs: number | null): number => {
  if (endTimeMs === null) {
    return 0;
  }
  const remainingMs = endTimeMs - Date.now();
  if (remainingMs <= 0) {
    return 0;
  }
  return remainingMs;
};

const incrementTickCount = (tickCount: number): number => tickCount + 1;

export const useTimeRemainingMs = (endTimeMs: number | null): number => {
  const [, scheduleTick] = useReducer(incrementTickCount, 0);

  useEffect(() => {
    if (endTimeMs === null) {
      return;
    }
    if (endTimeMs <= Date.now()) {
      return;
    }
    const intervalId = setInterval(() => {
      scheduleTick();
      if (endTimeMs <= Date.now()) {
        clearInterval(intervalId);
      }
    }, TICK_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [endTimeMs]);

  return computeRemainingMs(endTimeMs);
};
